module.exports = __webpack_public_path__ + "img/zjjh_1_black.80cd0325.png";